import { router } from "@inertiajs/vue3";
import ProductModel from "@/Interfaces/Product/ProductModel";
import { useToast } from "primevue/usetoast";
import { ref, watch } from "vue";

export const useSearchComposable = (term: string|null) => {
   const toast = useToast();
   const results = ref<string[]>([]);

    watch(term, async (newQuery) => {
        if (!newQuery) {
            results.value = [];
            return;
        }

        results.value = newQuery?.toLowerCase();
    });

    const searchProduct = () => {
        results.value?.length! >= 3 && results.value ? router.visit(route('product.search', {search_product: results.value}), {
            only: ['searchProducts', 'searchTerm'],
            onSuccess: (res) => {
            }
        }) : toast.add({ severity: 'error', summary: 'Error', detail: 'Search term should be min. 3 characters!', life: 1000 });
    }

    return { results, searchProduct };
}